import { BrowserRouter, Route, Routes as ReactRoutes } from 'react-router-dom';
import Home from '@/pages/home';
import Products from '@/pages/v1/products';

export default function Routes() {
  return (
    <BrowserRouter>
      <ReactRoutes>
        <Route path="/" element={<Home />} />
        <Route path="/v1/products" element={<Products />} />
      </ReactRoutes>
    </BrowserRouter>
  );
}
